import React, { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop({ hidden }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShow(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (hidden) return null;

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button className={`back-to-top ${show ? "show" : ""}`} onClick={scrollToTop}>
      <ArrowUp size={20} />
      <span className="tooltip">Retour en haut de la page</span>
    </button>
  );
}

